export enum ModalMultipleActionType {
	ASSIGN_CATEGORY = "category",
	ASSIGN_MEASURE_TYPE = "measure_type",
	ASSIGN_TAX = "tax",
	ASSIGN_CUSTOM_FIELDS = "custom_fields",
}

export enum ContactModalState {
	CLOSED,
	NEW,
	UPDATE,
}
